const initialState = {
    str: ''
}

const passportIssuedRed = (state = initialState, action) => {
    switch(action.type){
        case 'PASSPORT_ISSUED' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default passportIssuedRed